
import { RefStoredValue } from "../GeneralStoreHooks"
import * as locCon from "../../LocalConstants"
import * as libCon from "../../community-hats-js-library/Constants.js"
import { useState } from "react"
import { useEffect } from "react"
import { isNullOrUndefined } from "../../community-hats-js-library/utils/generalFunctions"
import { getIntervalSteps } from "../../utils/exhibitions/FlippingCardsExhibition.js"


const startDate = locCon.EXHIBITION_FC_START_DATE
const endDate = locCon.EXHIBITION_FC_END_DATE
const timeInterval = locCon.EXHIBITION_FC_TIME_INTERVAL
const frequency = locCon.EXHIBITION_FC_FREQUENCY
const minDataFrequency = locCon.EXHIBITION_FC_MIN_DATA_FREQUENCY

export const RefSimulationSteps = () => {

    const [steps, setSteps] = useState(null)

    useEffect(() => {
        setSteps(getIntervalSteps(startDate, endDate, timeInterval, frequency, minDataFrequency))
    }, [])

    return steps
}

export const RefParticipantData = () => {

    const dataStatus = RefStoredValue(locCon.EXHIBITION_FC_PARTICIPANT_DATA_STATUS)
    const rawData = RefStoredValue(locCon.EXHIBITION_FC_PARTICIPANT_DATA)


    const [status, setStatus] = useState(libCon.STATUS_NOT_STARTED)
    const [data, setData] = useState(null)
    const [sewaIds, setSewaIds] = useState(null)


    useEffect(() => {

        if (dataStatus === libCon.STATUS_OK && !isNullOrUndefined(rawData)) {
            setStatus(libCon.STATUS_LOADING)

            const intervalSteps = new Set(getIntervalSteps(startDate, endDate, timeInterval, frequency, minDataFrequency))

            let formatedData = {}

            Object.keys(rawData).forEach((k) => {
                let vals = rawData[k].filter(ob => intervalSteps.has(ob[libCon.DATETIME]))
                formatedData[k] = Object.fromEntries(vals.map(ob => [ob[libCon.DATETIME], { ...ob }]))
            })

            setData(formatedData)
            setSewaIds(Object.keys(formatedData))

            setStatus(libCon.STATUS_OK)


        }


    }, [dataStatus, rawData])

    return [status, data, sewaIds]

}


export const RefSateliteData = () => {

    const dataStatus = RefStoredValue(locCon.EXHIBITION_FC_SATELITE_WEATHER_STATUS)
    const rawData = RefStoredValue(locCon.EXHIBITION_FC_SATELITE_WEATHER)


    const [status, setStatus] = useState(libCon.STATUS_NOT_STARTED)
    const [data, setData] = useState(null)


    useEffect(() => {

        if (dataStatus === libCon.STATUS_OK && !isNullOrUndefined(rawData)) {
            setStatus(libCon.STATUS_LOADING)

            const intervalSteps = getIntervalSteps(startDate, endDate, timeInterval, frequency, minDataFrequency)

            // Transforms into map
            const dictFormatedData = Object.fromEntries(rawData.map(ob => [ob[libCon.DATETIME], { ...ob }]))

            const nullValue = { [libCon.TEMPERATURE]: null, [libCon.HUMIDITY]: null }
            const formatedData = intervalSteps.map(d => d in dictFormatedData ? dictFormatedData[d] : { [libCon.DATETIME]: d, ...nullValue })

            setData(formatedData)
            setStatus(libCon.STATUS_OK)


        }


    }, [dataStatus, rawData])

    return [status, data]

}

